import { Icon } from '@chakra-ui/react';
import {
  MdGroupWork,
  MdHome,
  MdOutlinePalette,
  MdPhotoCameraBack,
  MdWifiTethering,
  MdMergeType,
  MdOutlineAutoFixHigh,
  MdPersonOutline,
  MdFavoriteBorder,
} from 'react-icons/md';
import { FaWpexplorer } from "react-icons/fa";
import { RiAuctionLine } from 'react-icons/ri';
import { IoStorefrontOutline } from 'react-icons/io5';


// Admin Imports
import DashboardsDefault from 'views/admin/dashboards/default';
import ItemDetailsView from 'views/admin/main/ItemDetailsView';
import ExploreView from 'views/admin/main/ExploreView';
import ArtistOverviewView from 'views/admin/main/Artists/ArtistOverviewView';
import ArtistDetailsView from 'views/admin/main/Artists/ArtistDetailsView';
import GroupingOverview from 'views/admin/main/Groupings/GroupingOverviewView';
import GroupingDetailsView from 'views/admin/main/Groupings/GroupingDetailsView';
import MergeOverview from 'views/admin/main/Merges/MergeOverviewView';
import MergeDetailsView from 'views/admin/main/Merges/MergeDetailsView';
import ScrapejobOverview from 'views/admin/main/Scrapejobs/ScrapejobOverviewView';
import ScrapejobDetailsView from 'views/admin/main/Scrapejobs/ScrapejobDetailsView';
import ListingDetailsView from 'views/admin/main/Listings/ListingDetailsView';
import ListingDataSuggestionsOverview from 'views/admin/main/Listings/ListingDataSuggestions/ListingDataSuggestionsOverviewView';
import TradingFloorOverviewView from 'views/admin/main/TradingFloor/TradingFloorOverviewView';
import ItemOverviewView from 'views/admin/main/Items/ItemOverviewView';
import ItemDataSuggestionsOverview from 'views/admin/main/Items/ItemDataSuggestions/ItemDataSuggestionsOverviewView';
import ListingOverviewView from 'views/admin/main/Listings/ListingOverviewView';
import DedupItemOverviewView from 'views/admin/main/Dedup/DedupItemOverviewView';
import DedupListingOverviewView from 'views/admin/main/Dedup/DedupListingOverviewView';
import UsersOverviewView from 'views/admin/main/users/UsersOverviewView';
import PortfolioDetailsView from 'views/admin/main/Portfolios/PortfolioDetailsView';
import WishlistDetailsView from 'views/admin/main/Wishlists/WishlistDetailsView';

const routes = [
  // --- Dashboards ---
  {
    name: 'Dashboards',
    path: '/dashboards',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Main Dashboard',
        layout: '/admin',
        path: '/dashboards/default',
        component: <DashboardsDefault />,
        isMenu: true,
      },
    ],
  },

  {
    name: 'Explore',
    path: '/explore',
    icon: <Icon as={FaWpexplorer} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Explore All',
        layout: '/admin',
        path: '/explore',
        component: <ExploreView />,
        isMenu: true,
      },
    ],
  },
  {
    name: 'Artists',
    path: '/artist',
    icon: (
      <Icon
        as={MdOutlinePalette}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    collapse: true,
    items: [
      {
        name: 'Artist Overview',
        layout: '/admin',
        path: '/artists/all',
        component: <ArtistOverviewView />,
        secondary: true,
        isMenu: true,
      },
      {
        name: 'Artist Details',
        layout: '/admin',
        path: '/artist/:slug/:id',
        component: <ArtistDetailsView />,
        secondary: true,
        isMenu: false,
      },
      {
        name: 'Artist Details',
        layout: '/admin',
        path: '/artist/:id',
        component: <ArtistDetailsView />,
        secondary: true,
        isMenu: false,
      }
    ],
  },
  {
    name: 'Items',
    path: '/item',
    icon: <Icon as={MdPhotoCameraBack} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Item Overview',
        layout: '/admin',
        path: '/items/all',
        component: <ItemOverviewView />,
        secondary: true,
        isMenu: true,
      },
      {
        name: 'Data Suggestions',
        layout: '/admin',
        path: '/items/data-suggestions',
        component: <ItemDataSuggestionsOverview />,
        secondary: true,
        isMenu: true,
      },
      {
        name: 'Item Detail',
        layout: '/admin',
        path: '/item/:slug/:id',
        component: <ItemDetailsView />,
        secondary: true,
        isMenu: false,
      }
    ],
  },
  {
    name: 'Listings',
    path: '/listing',
    icon: <Icon as={RiAuctionLine} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Listing Overview',
        layout: '/admin',
        path: '/listings/all',
        component: <ListingOverviewView />,
        secondary: true,
        isMenu: true,
      },
      {
        name: 'Data Suggestions',
        layout: '/admin',
        path: '/listings/data-suggestions',
        component: <ListingDataSuggestionsOverview />,
        secondary: true,
        isMenu: true,
      },
      {
        name: 'Listing Detail',
        layout: '/admin',
        path: '/listing/:slug/:id',
        component: <ListingDetailsView />,
        secondary: true,
        isMenu: false,
      },
      {
        name: 'Listing Detail',
        layout: '/admin',
        path: '/listing/:id',
        component: <ListingDetailsView />,
        secondary: true,
        isMenu: false,
      }
    ],
  },
  {
    name: 'Dedup',
    path: '/dedup',
    icon: <Icon as={MdOutlineAutoFixHigh} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Dedup Listings',
        layout: '/admin',
        path: '/dedup-listings/all',
        component: <DedupListingOverviewView />,
        secondary: true,
        isMenu: true,
      },
      {
        name: 'Dedup Items',
        layout: '/admin',
        path: '/dedup-items/all',
        component: <DedupItemOverviewView />,
        secondary: true,
        isMenu: true,
      },
    ],
  },
  {
    name: 'Trading Floor',
    path: '/trading-floor',
    icon: <Icon as={IoStorefrontOutline} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Trading Floor Overview',
        layout: '/admin',
        path: '/trading-floor',
        component: <TradingFloorOverviewView />,
        isMenu: true,
      },
    ],
  },
  {
    name: 'Groupings',
    path: '/grouping',
    icon: <Icon as={MdGroupWork} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Grouping Overview',
        layout: '/admin',
        path: '/groupings/all',
        component: <GroupingOverview />,
        secondary: true,
        isMenu: true,
      },
      {
        name: 'Grouping Detail',
        layout: '/admin',
        path: '/groupings/details/:groupingId',
        component: <GroupingDetailsView />,
        secondary: true,
        isMenu: false,
      }
    ],
  },
  {
    name: 'Users',
    path: '/user',
    icon: <Icon as={MdPersonOutline} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'User Overview',
        layout: '/admin',
        path: '/users/all',
        component: <UsersOverviewView />,
        secondary: true,
        isMenu: true,
      },
    ],
  },
  {
    name: 'Portfolios',
    path: '/portfolio',
    icon: <Icon as={MdPersonOutline} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Portfolio Details',
        layout: '/admin',
        path: '/portfolio/:id',
        component: <PortfolioDetailsView />,
        secondary: true,
        isMenu: false,
      },
    ],
  },
  {
    name: 'Wishlists',
    path: '/wishlist',
    icon: <Icon as={MdFavoriteBorder} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Wishlist Details',
        layout: '/admin',
        path: '/wishlist/:id',
        component: <WishlistDetailsView />,
        secondary: true,
        isMenu: false,
      },
    ],
  },
  {
    name: 'Merges',
    path: '/merge',
    icon: <Icon as={MdMergeType} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Merge Overview',
        layout: '/admin',
        path: '/merges/all',
        component: <MergeOverview />,
        secondary: true,
        isMenu: true,
      },
      {
        name: 'Merge Detail',
        layout: '/admin',
        path: '/merges/details/:mergeId',
        component: <MergeDetailsView />,
        secondary: true,
        isMenu: false,
      }
    ],
  },
  {
    name: 'Scrapejobs',
    path: '/scrapejob',
    icon: <Icon as={MdWifiTethering} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Scrapejob Overview',
        layout: '/admin',
        path: '/scrapejobs/all',
        component: <ScrapejobOverview />,
        secondary: true,
        isMenu: true,
      },
      {
        name: 'Scrapejob Detail',
        layout: '/admin',
        path: '/scrapejobs/details/:scrapejobId',
        component: <ScrapejobDetailsView />,
        secondary: true,
        isMenu: false,
      }
    ],
  }
];

export default routes;
